import { createAction } from 'actions/utils'

export const TOGGLE_AFFINITY_HIGHLIGHT = 'TOGGLE_AFFINITY_HIGHLIGHT'
// queryUri belongs to the query that rungs on other
// query-sets reference as their inputs
export const toggleAffinityHighlight = (queryUri) => ({
  type: TOGGLE_AFFINITY_HIGHLIGHT,
  queryUri,
})

const RESET_AFFINITY_HIGHLIGHTS = 'RESET_AFFINITY_HIGHLIGHTS'
export const resetAffinityHighlights = createAction(RESET_AFFINITY_HIGHLIGHTS)
